import { Pipe, PipeTransform } from '@angular/core';
import { SettingsService } from '@app/_services/settings.service';

@Pipe({
    name: 'parseRemainingDays',
    standalone: true
})

export class ParseRemainingDaysPipe implements PipeTransform {
    constructor(private ss: SettingsService) { }
    transform(value: number | null): string {
        if (!value) return '';
        return this.ss.t('actionCommon_ending', { daysRemaining: value - 1 });
    }
}